import React from 'react';
export function Footer() {
  return <footer className="w-full py-8 px-4 md:px-8 bg-warm-brown/5 border-t border-warm-brown/10 mt-auto" data-id="element-99">
      <div className="max-w-4xl mx-auto text-center" data-id="element-100">
        <p className="text-xs md:text-sm text-gray-500 leading-relaxed max-w-3xl mx-auto" data-id="element-101">
          Dies ist ein persönlicher Erfahrungsbericht. Ergebnisse können
          individuell variieren. Ein Darmverschluss ist ein medizinischer
          Notfall – bitte immer sofort einen Tierarzt aufsuchen. Dieses Topping
          ersetzt keine tierärztliche Behandlung.
        </p>
        <div className="mt-6 text-xs text-gray-400" data-id="element-102">
          &copy; {new Date().getFullYear()} Napftagebuch. Alle Rechte
          vorbehalten.
        </div>
      </div>
    </footer>;
}